/**
 * FD Stage 3 quota helpers — pure functions behind the Rebuild button.
 *
 * Mirrors GET /api/concepts/{id}/field-debate/quota. `null` limits mean
 * unlimited (dev_mode or an unlimited plan tier) — no quota line, never
 * at-limit.
 */

export interface FieldDebateQuota {
  builds_used: number;
  builds_limit: number | null;
  refreshes_used: number;
  refreshes_limit: number | null;
}

/** Confirm-dialog copy for Rebuild: camp-shuffle warning, remaining-quota
 * line when a finite limit applies, and the pointer to Refresh. */
export function rebuildConfirmMessage(quota: FieldDebateQuota | undefined): string {
  const left =
    quota?.builds_limit != null
      ? ` You have ${Math.max(quota.builds_limit - quota.builds_used, 0)} of ${quota.builds_limit} rebuilds left this month.`
      : "";
  return (
    "Rebuild re-derives the camps from scratch — placements will shuffle " +
    `(camp structures typically overlap only ~50% between rebuilds).${left} ` +
    "To pull in new papers without changing existing placements, use Refresh instead. Continue?"
  );
}

/** True when a finite build limit exists and is exhausted. */
export function rebuildAtLimit(quota: FieldDebateQuota | undefined): boolean {
  return quota?.builds_limit != null && quota.builds_used >= quota.builds_limit;
}

export const REBUILD_LIMIT_TITLE =
  "Monthly rebuild limit reached — resets on the 1st";
